import React from 'react';

const Categories = () => (
  <h1 className="categoryMsg" style={{ textAlign: 'center' }}>Under construction 👷‍♂️</h1>
);

export default Categories;
